import React, {useState} from 'react'
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { useLocation, useNavigate } from 'react-router-dom';
//mui imports
import { Box, Button } from '@mui/material';

//internal imports
import { useSkidConfig, useSkidConfigDispatch } from '../components/AvailableSkids/SkidsProvider'
import ReportSelector from '../components/Report/ReportSelector';
import ReportPresenter from '../components/Report/ReportPresenter';

import {useTracker, useTrackerDispatch} from '../components/FetchTracker/FetchTrackerProvider'
import { loginRequest, protectedResources } from "../authConfig"
import {useSkidsWithConfig, useSkidsWithConfigDispatch} from '../components/AvailableSkids/skidsWithConfigProvider'
import { isPopulated, toSelectOptions } from '../components/AvailableSkids/skidsHelpers';
import { fetchAvailableSkidsWithConfig, fetchAvailableSkids } from '../Helper/Fetch/fetch';
import {getTZoffesetFromTZ} from '../Helper/timeHelpers';

interface LocationState{
    targetSkid: string
}

//component
function Report(){
    const locationState = useLocation().state as LocationState;
        var targetSkid = locationState?.targetSkid
        if (!targetSkid){
            targetSkid = ''
        }
    const { instance, accounts, inProgress } = useMsal();
    const Skids = useSkidConfig()
    const SkidDispatch = useSkidConfigDispatch()
    const skidsWithConfig = useSkidsWithConfig()
    const skidsWithConfigDispatch = useSkidsWithConfigDispatch()
    const Tracker = useTracker()
    const TrackerDispatch = useTrackerDispatch()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [data, setData] = useState<ArrayBuffer>(null)
    const [message,setMessage] = useState('Select Skid to get Started')
    const request = {scopes: protectedResources.whoami.scopes,account: accounts[0]}

    function handleFetchResp(resp:Promise<Response>){
        resp.then(res => {
            if (res.status >= 400){
                throw new Error("Server Encoutered a problem while generating PDF")
            }
            return res.blob()
        }).then((blob)=>{
            if(blob){
                blob.arrayBuffer().then(buffer => {
                    setData(buffer)
                    setLoading(false)
                })
            }
        }).catch(error =>{
            setError(error.message);
            setLoading(false)
        })
    }
    //Checks for refetch condition, 0 skids and no previous fetch
    if (Skids.size === 0 && Tracker.skid === false){ 
            console.log('No Skids Available, and no previous fetch, starting refetch')
            fetchAvailableSkids(request, instance).then((res => res.json())).then((items)=>{
                SkidDispatch({type:'addSkids',skids:items.skids})
                TrackerDispatch({type:'skid',value:true})
            })
    }

    return(
        <Box className='View-Box'>
           <ReportSelector initialSkid={targetSkid} skids={Skids} setLoading={setLoading} dataHandler={handleFetchResp} setMessage={setMessage}/>
           <ReportPresenter data={data} error={error} loading={loading} message={message}/>
        </Box>
    )
}

export default Report